module.exports = __webpack_public_path__ + "static/media/skills-mapping-img-006.1741f4c1.jpg";